export const searchData = (e, projects, setSearchResults) => {
    setSearchResults(
        projects?.filter(dataContainsTerm(e))
    );
  };

const dataContainsTerm = (term) => {
    return function (element) {
        let word = term?.toString().toLowerCase();
        let data = element;
        if (data.AuthorFirstName.toString().toLowerCase().includes(word) &&
            startsWith(data.AuthorFirstName.toString().toLowerCase(), word)) {
                return true;
        } else if (data.AuthorLastName.toString().toLowerCase().includes(word) || 
            startsWith(data.AuthorLastName.toString().toLowerCase(), word)) {
                return true;
        } else if (data.ProspectName.toString().toLowerCase().includes(word) || 
        startsWith(data.ProspectName.toString().toLowerCase(), word)) {
            return true;
        }

        return false;
    };
};

function startsWith(str, word) {
    return str.lastIndexOf(word, 0) === 0;
}